module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/particular01-d549e36668f181019c50efa7c79360a3.png";